import Vue from "vue";
import Vuex from "vuex";
import common from "./common";
// import getCode from "./modules/getCode";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    // getCode
  }
});
